import React, { useState } from 'react';

import InputCheckbox from '../InputCheckbox';
import { Row } from '../../Structure';
import useDeclarationData from '../../../hooks/useDeclarationData';

const SignatureCheckboxs = ({ onChange }) => {
  const [values, setValues] = useState(useDeclarationData());

  const updateChecked = (event) => {
    onChange({ name: event.name, value: event.checked });
    const { name, checked } = event;
    values[name] = checked;
    setValues({ ...values });
  };

  return (
    <>
      <Row>
        <InputCheckbox
          name="declaration"
          onChange={updateChecked}
          required
          checked={values.declaration}
        >
          By checking this box, I certify that the details on this application are correct to the best of my knowledge. I understand that I may be contacted to confirm the details that have been given.
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="signedLogbook"
          onChange={updateChecked}
          required
          checked={values.signedLogbook}
        >
          By checking this box, I confirm that the Card Holder will make their logbook available for audit and understand that if they cannot produce the completed logbook, then the card application may be revoked.
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="terms"
          onChange={updateChecked}
          required
          checked={values.terms}
        >
          I agree to the{' '}
          <a
            className="tw-font-medium tw-text-blue-500 tw-underline"
            href="https://cpcs.nocn.org.uk/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Term Privacy Policy.
          </a>
        </InputCheckbox>
      </Row>
    </>
  );
};

export default SignatureCheckboxs;
